<script lang="ts">
  import { gameStart, gameState } from "../stores/winState";
  import LevelsScreen from "./LevelsScreen.svelte";
  import { onMount } from "svelte";
  import Icon from "../components/Icon.svelte";
  import SplashLogo from "./components/SplashLogo.svelte";
  import { fade, fly } from "svelte/transition";

  onMount(() => {
    document.body.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
  });
</script>

{#if $gameState === "splash"}
  <div class="splash-wrapper">
    <div class="seperation-line" />
    <SplashLogo />
    <div class="buttons-wrapper animate">
      <div class="button-wrapper">
        <div
          class="indication-circle main-menu"
          on:click={() => {
            $gameState = "level";
            $gameStart = false;
          }}
        >
          <div class="halo" />
          <Icon name="play" width={38} height={38} color={"#c7ddcc"} />
          <h5>play</h5>
        </div>
      </div>
      <div class="button-wrapper ">
        <div class="indication-circle main-menu">
          <div class="halo" />
          <Icon name="settings" width={35} height={35} color={"#c7ddcc"} />
          <h5>settings</h5>
        </div>
      </div>
      <div class="button-wrapper">
        <div class="indication-circle main-menu">
          <div class="halo" />
          <Icon name="about" width={35} height={35} color={"#c7ddcc"} />
          <h5>about</h5>
        </div>
      </div>
    </div>
    <div class="developed-by">Designed and developed by jacob kaled 2022</div>
  </div>
{:else if $gameState === "level"}
  <LevelsScreen />
{/if}

<style>
  .splash-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    gap: 30px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 20;
  }
  .seperation-line {
    position: absolute;
    left: calc(50%-3px);
    top: 0;
    width: 1px;
    border-left: 4px dashed #16123f;
    height: 96%;
    z-index: 0;
  }
  .buttons-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    padding: 10px 0;
    z-index: 2;
  }
  .indication-circle {
    cursor: pointer;
    width: 20px;
    height: 20px;
    border: 4px solid transparent;
    background-color: #202020;
    border-radius: 2px;
    z-index: 3;
  }

  .indication-circle:hover h5 {
    display: block;
    color: white;
  }
  .indication-circle :global(svg) {
    z-index: 10;
  }
  .indication-circle:hover .halo {
    color: white;
    display: block;
    animation: blink 1s infinite;
    transform: scale(1);
  }
  .indication-circle .halo {
    display: none;
    position: absolute;
    border-radius: 100%;
    width: 70px;
    height: 70px;
    z-index: 1;
    border: 5px solid black;
    transform: scale(0);
    transition: all 0.2s;
  }

  .indication-circle h5 {
    display: none;
  }
  .indication-circle:hover :global(svg) {
    display: none;
  }
  .main-menu {
    width: 55px;
    height: 55px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* .absolute {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		margin-left: 164px;
		margin-top: -28px;
		border-color: black;
		background-color: #16123f;
	}
	.v2 {
		font-family: 'Times New Roman', Times, serif;
		margin: 0 auto;
		margin-top: 50px;
		font-size: 40px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 30px;
		width: 40px;
		height: 40px;
		padding: 5px;
		background-color: #16123f;
		font-weight: bolder;
		color: white;
		z-index: 10;
	} */
  /* .background-circle {
    position: absolute;
    width: 300px;
    height: 300px;
    top: -260px;
    border-radius: 100px;
    border: 30px solid #75c9b7;
    opacity: 0.6;
  } */
  /* .game-logo {
		z-index: inherit;
	}
	.game-logo h1 {
		text-transform: uppercase;
		font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial,
			sans-serif !important;
		color: #16123f;
		font-size: 60px;
		margin: -20px 0;
		padding-top: 30px;
		line-height: 20%;
	}
	.game-logo h1 span:first-child {
		letter-spacing: -5px;
		margin-right: 25px;
		z-index: 3;
	}
	.game-logo h5 {
		text-transform: uppercase;
		text-align: center;
		color: #16123f;
		font-size: 20px;
		margin: 15px 0;
		padding-left: 13px;
		font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial,
			sans-serif !important;
	}
	h6 {
		font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial,
			sans-serif;
		text-transform: uppercase;
		font-size: 10px;
		font-weight: bolder;
		color: #c7ddcc;
	} */
  .developed-by {
    position: absolute;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
      "Lucida Sans", Arial, sans-serif;
    bottom: 10px;
    font-size: 12px;
  }
  .animate {
    opacity: 0;
    animation: anim 0.5s forwards ease-out;
    animation-delay: 0.4s;
  }

  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes anim {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
</style>
